import Handlebars from 'handlebars';

Handlebars.registerHelper('trimString', function (passedString) {
  var theString = passedString;
  if (theString.length > 165) {
    theString = theString.substring(0, 161) + '...';
  }
  return new Handlebars.SafeString(theString)
});
